import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuánto tiempo debo dedicar por día?',
  a: 'El programa está diseñado para mujeres ocupadas. Necesitarás entre 20 y 40 minutos diarios, que puedes distribuir según tu horario. La flexibilidad es clave en nuestro método.'
}, {
  q: '¿Funciona si tengo condiciones de salud especiales?',
  a: 'RenuevaTE_90 es un programa de bienestar integral, no un tratamiento médico. Si tienes condiciones como hipotiroidismo, SOP o diabetes, los pilares te ayudarán enormemente, pero siempre debes consultar con tu médico y adaptar las recomendaciones a tu caso.'
}, {
  q: '¿Qué pasa si me atraso en el programa?',
  a: "¡No pasa nada! Tienes acceso al material por 6 meses. La idea es avanzar a tu ritmo, sin la presión de 'quedar atrás'. Nuestro equipo te ayudará a retomar cuando lo necesites."
}, {
  q: '¿Hay soporte durante los 90 días?',
  a: 'Sí, absoluto. Tienes acceso a la comunidad privada 24/7, sesiones grupales en vivo semanales para resolver dudas, y seguimiento de tu progreso.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'La mayoría de nuestras alumnas reportan mejoras en su energía y digestión en los primeros 10-14 días. Los cambios físicos y de composición corporal se hacen evidentes entre la semana 4 y 6, consolidándose a los 90 días.'
}, {
  q: '¿Es para mí si ya hice mil dietas antes?',
  a: 'Especialmente para ti. Este programa fue creado exactamente para romper ese ciclo. No nos enfocamos en la restricción, sino en sanar tu metabolismo y tu relación con la comida.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream relative" data-id="element-59">
      <div className="max-w-3xl mx-auto px-6" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-61">
          <h2 className="font-serif text-3xl md:text-5xl mb-6 text-[#0D1B3E]" data-id="element-62">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-63"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl border border-navy/10 overflow-hidden shadow-sm" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-66">
                <span className="font-serif text-lg font-medium pr-8 text-[#0D1B3E]" data-id="element-67">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>

              <AnimatePresence data-id="element-69">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-70">
                    <div className="px-6 pb-5 text-navy/70 leading-relaxed" data-id="element-71">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}